import React from 'react';

const LoginIllustration = () => {
  return (
    <div className="w-full h-full flex items-center justify-center p-8">
      <svg
        viewBox="0 0 800 600"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-auto max-w-[600px] drop-shadow-xl"
      >
        <defs>
          <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="10" />
            <feOffset dx="0" dy="10" result="offsetblur" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.1" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <linearGradient id="bgGradient" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#E5FAFF" />
            <stop offset="100%" stopColor="#F0F9FF" />
          </linearGradient>
          <linearGradient id="cardGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FFFFFF" />
            <stop offset="100%" stopColor="#F8FAFC" />
          </linearGradient>
          <linearGradient id="primaryGradient" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#0BAFD4" />
            <stop offset="100%" stopColor="#22D3EE" />
          </linearGradient>
        </defs>

        {/* Background Abstract Shapes */}
        <circle cx="400" cy="300" r="280" fill="url(#bgGradient)" />
        <circle cx="650" cy="100" r="40" fill="#FEF3C7" opacity="0.6" />
        <circle cx="150" cy="500" r="60" fill="#DBEAFE" opacity="0.6" />
        
        {/* Main Dashboard Window */}
        <g filter="url(#shadow)">
          <rect x="150" y="120" width="500" height="360" rx="16" fill="white" />
          
          {/* Header */}
          <path d="M150 136C150 127.163 157.163 120 166 120H634C642.837 120 650 127.163 650 136V160H150V136Z" fill="#F1F5F9" />
          <circle cx="180" cy="140" r="5" fill="#EF4444" />
          <circle cx="200" cy="140" r="5" fill="#F59E0B" />
          <circle cx="220" cy="140" r="5" fill="#10B981" />

          {/* Sidebar */}
          <rect x="150" y="160" width="120" height="320" fill="#F8FAFC" />
          <rect x="170" y="190" width="80" height="10" rx="3" fill="#E2E8F0" />
          <rect x="170" y="220" width="60" height="8" rx="2" fill="#CBD5E1" />
          <rect x="170" y="245" width="70" height="8" rx="2" fill="#CBD5E1" />
          <rect x="170" y="270" width="65" height="8" rx="2" fill="#CBD5E1" />
          <path d="M150 464C150 472.837 157.163 480 166 480H270V160H150V464Z" fill="#F8FAFC" opacity="0" />

          {/* Main Content Area */}
          <rect x="290" y="190" width="140" height="20" rx="4" fill="#1E4387" opacity="0.9" />
          <rect x="450" y="190" width="100" height="20" rx="4" fill="#E2E8F0" />
          
          {/* Chart Area */}
          <g transform="translate(290, 240)">
            <rect width="320" height="160" rx="8" fill="#F8FAFC" stroke="#E2E8F0" />
            
            {/* Y-axis lines */}
            <line x1="20" y1="40" x2="300" y2="40" stroke="#E2E8F0" strokeDasharray="4 4" />
            <line x1="20" y1="80" x2="300" y2="80" stroke="#E2E8F0" strokeDasharray="4 4" />
            <line x1="20" y1="120" x2="300" y2="120" stroke="#E2E8F0" strokeDasharray="4 4" />
            
            {/* Bar Chart */}
            <rect x="40" y="60" width="24" height="80" rx="2" fill="url(#primaryGradient)" opacity="0.6" />
            <rect x="80" y="30" width="24" height="110" rx="2" fill="url(#primaryGradient)" />
            <rect x="120" y="80" width="24" height="60" rx="2" fill="url(#primaryGradient)" opacity="0.5" />
            <rect x="160" y="50" width="24" height="90" rx="2" fill="url(#primaryGradient)" opacity="0.8" />
            <rect x="200" y="90" width="24" height="50" rx="2" fill="url(#primaryGradient)" opacity="0.4" />
            <rect x="240" y="40" width="24" height="100" rx="2" fill="url(#primaryGradient)" opacity="0.9" />
          </g>
        </g>

        {/* Floating Stat Card - Users */}
        <g transform="translate(580, 380)" filter="url(#shadow)">
          <rect width="140" height="90" rx="12" fill="white" />
          <circle cx="35" cy="35" r="18" fill="#EFF6FF" />
          <path d="M35 26C37.2091 26 39 27.7909 39 30C39 32.2091 37.2091 34 35 34C32.7909 34 31 32.2091 31 30C31 27.7909 32.7909 26 35 26ZM35 44C30.5817 44 27 40.4183 27 36H43C43 40.4183 39.4183 44 35 44Z" fill="#1E4387" />
          <rect x="65" y="25" width="50" height="8" rx="4" fill="#94A3B8" />
          <rect x="65" y="40" width="30" height="8" rx="4" fill="#CBD5E1" />
          <text x="25" y="75" fill="#1E4387" fontSize="16" fontWeight="bold" fontFamily="sans-serif">1,248</text>
          <text x="75" y="75" fill="#10B981" fontSize="10" fontWeight="bold" fontFamily="sans-serif">+12%</text>
        </g>

        {/* Floating Stat Card - Admin Badge */}
        <g transform="translate(80, 400)" filter="url(#shadow)">
           <rect width="160" height="60" rx="30" fill="white" />
           <circle cx="35" cy="30" r="20" fill="#0BAFD4" />
           <path d="M35 20L40 30H30L35 20Z" fill="white" /> 
           <path d="M28 28L42 28L35 40L28 28Z" fill="white" opacity="0.8"/>
           <text x="65" y="35" fill="#334155" fontSize="14" fontWeight="bold" fontFamily="sans-serif">Super Admin</text>
        </g>

        {/* Decorative Elements */}
        <path d="M680 250 L700 230 L720 250 L700 270 Z" fill="#F472B6" opacity="0.6" />
        <circle cx="100" cy="200" r="8" fill="#0BAFD4" opacity="0.4" />
        <rect x="700" y="450" width="15" height="15" rx="2" transform="rotate(15 700 450)" fill="#1E4387" opacity="0.2" />

      </svg>
    </div>
  );
};

export default LoginIllustration;